import React, { forwardRef } from 'react';

import MUIDialogContent, {
  DialogContentProps as MUIDialogContentProps,
} from '@material-ui/core/DialogContent';

interface DialogContentProps extends MUIDialogContentProps {}

const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
  (props, ref) => {
    return (
      <MUIDialogContent {...props} ref={ref}>
        {props.children}
      </MUIDialogContent>
    );
  }
);

DialogContent.displayName = 'DialogContent';

export default DialogContent;
